<template>
    <div class="col-12">
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-lg-6" style="">
                        <!-- <input type="text" class="form-control" v-model="content.title" placeholder="Title Letter" /> -->
                    </div>
                    <div class="col-lg-6" style="">
                        <!-- <div class="row form-inline">
                            <div class="my-1 mr-2" style="margin-right: 5px;margin-left: 15px;">
                                <label for="contractLetter">
                                    Include this document?
                                </label>
                            </div>
                            <div class="custom-control custom-checkbox my-1 mr-sm-2">
                                <input type="checkbox" class="custom-control-input" id="contractLetter" v-model="form.letter" @change="setUpdate"/>
                                <label class="custom-control-label" for="contractLetter">Yes</label>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="col-12" style="margin-top: 0px;">
                <vue-editor class="simpleLetter" v-model="content.description" @text-change="setUpdate" :editor-toolbar="customToolbar"
                :customModules="customModulesForEditor" :editorOptions="editorSettings" useCustomImageHandler
                @image-added="handleImageAdded" @image-removed="handleImageDeleted"/>
            </div>
        </div>
    </div>
</template>
<script>
import './simpleLetter.scss';
import { VueEditor, Quill } from 'vue2-editor';
// import { ImageDrop } from 'quill-image-drop-module';
import ImageResize from "quill-image-resize-module";
export default {
    components: {
        VueEditor,
    },
    name: 'simpleLetter',
    props: {
        propForm: {
            type: Object,
            required: true
        },
        propTemplateLetter: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            content: this.propTemplateLetter,
            customToolbar: [
                [
                    { header: [1, 2, 3, 4, 5, 6, false] },
                    "bold", "italic", "underline", "strike",
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" },
                    { list: "ordered" },
                    { list: "bullet" },
                    { color: [] },
                    "link",
                    "image",
                    "clean"
                ]
            ],
            customModulesForEditor: [
                // { alias: "imageDrop", module: ImageDrop },
                { alias: "imageResize", module: ImageResize }
            ],
            editorSettings: {
                modules: {
                    // imageDrop: true,
                    imageResize: ImageResize
                }
            },
            form: this.propForm,
        };
    },
    methods: {
        setUpdate() {
            this.$emit('updateLetter',{
                'letter': this.form.letter,
                'description': this.content.description,
                'title': this.content.title,
            });
        },
        handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
            let t = this;
            var setImage = new FormData();
            setImage.append("user_id", window.master_client);
            setImage.append("org_id", window.localorgdata);
            setImage.append("folder", 'so_task');
            setImage.append("img1", file, file.name);
            setImage.append("nombreIMG", "img");
            setImage.append("task_id", new Date().getTime().toString());
            setImage.append("contIMG", 1);
            setImage.append("delIMG", "imgOld");
            setImage.append("contDel", 0);
            window.masterGetBilling
            .post("subirIMG", setImage)
            .then(result => {
                let url = window.urlmaster+'images/no-image.png'; // imagen x defaul
                let name_image = '';
                if(result.data.imgs["1"]){
                    url = window.urlmaster + result.data.rooPath.slice(1) + result.data.imgs["1"];
                    name_image = result.data.imgs["1"];
                    Editor.insertEmbed(cursorLocation, "image", url);
                    // Espera un momento para que Quill inserte el DOM y luego accede a la imagen
                    setTimeout(() => {
                        const editorEl = document.querySelector('.ql-editor');
                        const imgs = editorEl.querySelectorAll('img');
                        const lastImg = imgs[imgs.length - 1];
                        if (lastImg && lastImg.src === url) {
                        lastImg.classList.add('img-editor-custom');
                        lastImg.setAttribute('width', '200px'); // ⬅ ancho inicial
                        lastImg.setAttribute('height', 'auto'); // mantiene proporción
                        }
                    }, 10);
                    resetUploader();
                }else{
                    t.$notify({
                        group: "noti",
                        type: "error",
                        title: "Error:",
                        text: "Image upload failed, please try again.",
                    });
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        handleImageDeleted: function (file, Editor, cursorLocation, resetUploader) {
            console.log('handleImageDeleted', file, Editor, cursorLocation, resetUploader)
            let t = this;
            file = file.split('so_task/');
            var setImage = new FormData();
            setImage.append("user_id", window.master_client);
            setImage.append("org_id", window.localorgdata);
            setImage.append("folder", 'so_task');
            setImage.append("image", file[1]);
            window.masterGetBilling
            .post("delOnlyIMG", setImage)
            .then(result => {
                let url = window.urlmaster+'images/no-image.png'; // imagen x defaul
                let name_image = '';
                if(!result.data.status){
                    console.log('delOnlyIMG', result.data)
                }else{
                    t.$notify({
                        group: "noti",
                        type: "error",
                        title: "Error:",
                        text: "Image upload failed, please try again.",
                    });
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
    }
}
</script>
